export interface SubtitlesConfig {
  defaultPositions: SubtitlesPositions;
}

export interface Subtitle {
  text: string;
  isFinal?: boolean;
}

export enum SubtitlesFramework {
  SCALED = 'scaled',
  RESPONSIVE = 'responsive',
}

export enum SubtitlesDevice {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export enum SubtitlesTextSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type SubtitlesSize = Record<SubtitlesDevice, SubtitlesTextSize>;

export enum SubtitlesViewport {
  DESKTOP = 'desktop',
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export const VIEWPORT_DEVICE_MAP = {
  [SubtitlesViewport.DESKTOP]: SubtitlesDevice.DESKTOP,
  [SubtitlesViewport.PORTRAIT]: SubtitlesDevice.MOBILE,
  [SubtitlesViewport.LANDSCAPE]: SubtitlesDevice.MOBILE,
};

export interface SubtitlesAlertMessages {
  onboarding: string;
}

export type SubtitlesPosition = Record<'x' | 'y', number>; // Value between 0 and 1

export type SubtitlesPositions = Record<SubtitlesViewport, SubtitlesPosition>;

export type PositionAlignment = 'start' | 'center' | 'end';

export type CenterPositionMarker = [centerBeginMarker: number, centerFinishMarker: number];

export type SubtitlesPositionInfo = {
  xAlign: PositionAlignment;
  yAlign: PositionAlignment;
  xValue: number;
  yValue: number;
};

export type Vector = Record<'x' | 'y', number>;

export interface SubtitlesDragObject {
  dragging: boolean;
  // When drag starts, stores the initial cursor position.
  originVector: Vector | null;
  // When dragging, stores the cursor movement from the initial cursor position (originVector).
  deltaVector: Vector | null;
  // When dragging, stores the current position information to save on drag end.
  positionInfo: SubtitlesPositionInfo | null;
  // When drag starts, stores the offset between initial position and cursor position,
  // will be used to align the subtitles w.r.to the cursor position on subtitle change during dragging.
  originOffset: Vector | null;
}

export type PositionStyle = Record<
  'top' | 'right' | 'bottom' | 'left' | 'marginTop' | 'marginLeft' | 'alignItems' | 'justifyContent',
  string | undefined
>;
